// File: src/layouts/NoNavLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function NoNavLayout() {
  return (
    <>
      {/* No TopNav here */}
      <Outlet />
    </>
  );
}
